import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "openingHours" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 id=\"title\">oFFNUNGSZEITEN</h1><p>Montag - Donnerstag</p><p>12:00 Uhr - 01:00 Uhr</p><p>-------</p><p>Freitag</p><p>12:00 Uhr - 03:00 Uhr</p><p>-------</p><p>Samstag</p><p>14:00 Uhr - 03:00 Uhr</p><p>-------</p><p>Sonntag</p><p>14:00 Uhr - 01:00 Uhr</p>", 12)
const _hoisted_14 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_14))
}